import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { SettingsRes } from 'features/dashboard'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'

export const useFetchStoreSettings = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)

	const {
		data: storeSettings,
		isLoading: isStoreSettingsLoading,
		isSuccess: isStoreSettingsSuccess
	} = useQuery<SettingsRes>({
		queryKey: queryKeys.storeSettings.all,
		queryFn: () => axiosPrivate.get(apiRoutes.settings),
		enabled: !!auth.accessToken
	})

	return {
		storeSettings,
		isStoreSettingsLoading,
		isStoreSettingsSuccess
	}
}
